export default function shareOnFacebook() {
  window.open(`https://www.facebook.com/sharer/sharer.php?u=https://lofi.cafe`);
}
